export default {"src":"/_next/static/media/icon_loader.1c24ff93.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};